import axios from "axios";
// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
  GetVendor({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  GetVendorList({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/vendor/list?order_by=${list.order_by || 'created_on'}&order_dir=${list.order_dir || 'desc'}`,
        params: {
          page: list.page ? list.page : 0,
          vendor_type: list.vendor_type ? list.vendor_type : '',
          vendor_name: list.vendor_name ? '*' + list.vendor_name + '*' : '',
          per_page: list.per_page ? list.per_page : 10,
          status: list.is_active ? "active" : '',
          order_by: list.order_by,
          order_dir: list.order_dir,
        },
        method: "GET"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  AddVendor({ commit }, vendor) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor",
        data: vendor,
        method: "POST"
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  },
  EditVendor({ commit }, vendor) {
    return new Promise((resolve, reject) => {
      axios({
        url: "vendor/" + vendor.id,
        data: vendor.vendor,
        method: "PATCH"
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  },
  DeleteVendor({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "vendor/" + id,
        method: "DELETE"
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  }
};

// mutations
const mutations = {
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
